export const initialState = {
  countries: [],
  definedCountries: []
};
